import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContentStateProperty, FieldProps } from '../../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../../@types/validation-types'
import Checkbox from '../../../../../../common/inputs/checkbox/Checkbox'

const property = 'consumptionContainsWarmWater'

export interface ConsumptionContainsWarmWaterProps extends Omit<
  FieldProps<ConstructionScreenValidationResult>,
  'onChange'
> {
  onEnergyCertificateChange: (field: ContentStateProperty, value: string | boolean | undefined) => void
}

const ConsumptionContainsWarmWaterField: React.FC<ConsumptionContainsWarmWaterProps> = ({
  insertionData,
  onEnergyCertificateChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className='grid-item one-whole'>
      <Checkbox
        id='consumption-contains-warm-water'
        onChange={(name, checked) => onEnergyCertificateChange(name, checked)}
        name={property}
        checked={insertionData.consumptionContainsWarmWater!}
        label={
          <span>{t('wizard.screen.construction.consumptionContainsWarmWater', 'Consumption contains warm water')}</span>
        }
      />
    </div>
  )
}

export default ConsumptionContainsWarmWaterField
